export default (configuration?: string | { apiHost: string }) => {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_DEV_ENV !== 'true') {
    return {
      askV2: process.env.REACT_APP_ASKV2_API_URL,
      assetsV2: process.env.REACT_APP_ASSETSV2_API_URL,
      assetCookies: process.env.REACT_APP_ASSETCOOKIES_API_URL,
      audit: process.env.REACT_APP_AUDIT_API_URL,
      catalog: process.env.REACT_APP_CATALOG_API_URL,
      channelconnections: process.env.REACT_APP_CHANNEL_CONNECTION_API_URL,
      console: `${window.location.origin}${process.env.PUBLIC_URL}`,
      feedback: process.env.REACT_APP_FEEDBACK_API_URL,
      knowledge: process.env.REACT_APP_KNOWLEDGE_API_URL,
      publisher: process.env.REACT_APP_PUBLISHER_URL,
      publisherV2: process.env.REACT_APP_PUBLISHERV2_URL,
      tenant: process.env.REACT_APP_ADMIN_API_URL,
      discover: process.env.REACT_APP_DISCOVER_API_URL
    }
  }

  const apiHost = typeof configuration === 'object' ? configuration.apiHost : configuration

  return {
    askV2: `${apiHost}/v2/ask`,
    assetsV2: `${apiHost}/v2/assets`,
    assetCookies: `${apiHost}/v1/cookies`,
    audit: `${apiHost}/v1/audit`,
    catalog: `${apiHost}/v1/catalog`,
    console: `${apiHost}${process.env.PUBLIC_URL}`,
    channelconnections: `${apiHost}/v1/admin/organizations/:organizationId/channel-connections`,
    feedback: `${apiHost}/v1/feedback`,
    knowledge: `${apiHost}/v1/knowledge`,
    knowledgeV2: `${apiHost}/v2/knowledge`,
    publisher: `${apiHost}/v1/publisher`,
    publisherV2: `${apiHost}/v2/publisher`,
    tenant: `${apiHost}/v1/admin`,
    apps: `${apiHost}/v2/apps`,
    microapp: `${apiHost}/v1`,
    appbuilder: `${apiHost}/v1/appbuilder`,
    appbuilderV2: `${apiHost}/v2/appbuilder`,
    appbuilderV3: `${apiHost}/v3/appbuilder`,
    discover: `${apiHost}/v1/discover`,
    notificationSources: `${apiHost}/v1/sources`
  }
}
